import { createStyles, makeStyles } from "@material-ui/core";
import * as React from "react";
import { IYoelloTheme } from "../yoello-lib/modules/themes/IYoelloTheme";

export interface LogoProps {
  height?: string;
  hidePayLogo?: boolean;
}

const useStyles = makeStyles((theme: IYoelloTheme) => {
  return createStyles({
    logo: {
      content: `url(${theme.images.logo})`, //url(${theme.images.logo}), 
      backgroundRepeat: 'no-repeat',
      boxSizing: "border-box",
      width: "90%",
      height: "auto",
      margin: 0,
      padding: "1rem",
      "@media(max-width: 425px)": {
        padding: "0 2rem",
      },
      "@media(max-width: 375px)": {
        padding: "0 3rem",
      }
    }
  })
})

const Logo = (props: LogoProps) => {
  const { logo } = useStyles();
  return (
    <div style={{
      width: "100%",
      position: "relative",
      height: "100%",
      textAlign:"center"
    }}>
      <img
        className={logo}
        style={{ height: props.height, objectFit: "contain" }}
        alt=""
      />

    </div>
  );
};



export default Logo;
